import { Component, OnInit, Input } from '@angular/core';
import { Maintenance } from '../../../model/maintenance'
import { MaintenanceService  } from '../../../service/lazarus/maintenance.service'
import * as moment from 'moment'
import Swal from 'sweetalert2';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

  @Input() user:Maintenance = new Maintenance

  protected maxItemsPerPage: number;
  protected page: number = 1;
  protected total: number;
  protected keyword: string;

  protected loading: boolean = false;

  genderList:any = [
     {
       id: 1,
       value:'Male'
     },
     {
      id: 2,
      value:'Female'
    }
  ]

  @Input() result:any;
  @Input() test:any = 1
  
  is_loaded:boolean = false
  formStructure:[] //Data Returned
  tableList:any = [] //List of tables

  tableRecords:any = []

  getTableList(){
    this.loading = true
    this.api.getTableForm().subscribe(
      (data:any) => {
         this.tableList = data
         this.loading = false
      }
    )
  }

  generateForm(tblName){
       this.api.getForms(tblName).subscribe(
      (data:any) => {
         this.result = data.fields
         this.formStructure = data.tableList
         this.tableName = data.table_name
         console.log(JSON.stringify(this.result))
         this.is_loaded = true

         this.initializeComponents();
      }
    )
  }

  tableName = '';


  constructor(
    private api:MaintenanceService,
  ) { }

  ngOnInit() {
   

    this.getTableList()

  }

  saveRecords(res){

    const form_data = 
       {
         'data':res,
         'table_name': this.tableName
       }
       this.loading = true
     this.api.saveRecords(form_data).subscribe(
       (d) => {
        Swal.fire(
          'Save record',
          'Record has been saved on table ' + this.tableName,
          'success'
        )
          this.initializeComponents()
          this.loading = false
       },
       (err) => {
         alert('erro saving:' + JSON.stringify(err))
         this.loading = false
       }
     )
  }

  private initializeComponents() {
    this.maxItemsPerPage = 10;
    this.page = 1;
    this.keyword = '';
    this.loadRecords(this.maxItemsPerPage,this.page,this.keyword)
  }

  loadRecords(maxItemsPerPage:number,page: number,keyword:string){
    this.loading = true;
     this.api.getRecords(this.tableName,maxItemsPerPage,page,keyword).subscribe(
       (data:any) => {
          this.tableRecords = data.data
          this.total = data.total;
          this.loading = false;
       }
     )
  }

  viewRecords(r){
     for(let i =0; i < this.formStructure.length; i++){
        let colName = this.formStructure[i]['column_name']
        let colType = this.formStructure[i]['column_type']
        let row = r[colName]
        if(colType =='date'){
          if(this.isDate(row)){
            r[colName] = moment(r[colName]).format('YYYY-MM-DD')
          }
        }else if(colType=='select_table' || colType=='radio_table' ){
           r[colName] = +r[colName]
        }
     }
     console.log(r)
     this.result = r
  }

  //Getting the options for viewing on the table
  getOptions(value,column_name,col_type){
    if(col_type =='select' || col_type =='select_table' || col_type=='radio' || col_type =='radio_table'){
      for(let i =0; i < this.formStructure.length; i++){
        const colName = this.formStructure[i]['column_name']
        const colType = this.formStructure[i]['column_type']
        const options:[] = this.formStructure[i]['options']
        
        if(colName==column_name){          
          for(let x =0; x < options.length ;x++){
            const opt = options[x]
            if(opt['value'] == value){
              return opt['label']
            }
          }
        }
      }//End For
    }else{
      return value
    }
   
  }

  isDate(dateString) {
    return moment(dateString).isValid()
  }

}
